var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shocked_svg__clip0_2637_47653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 30.5c0 13.176-9.993 24.018-22.813 25.36-.883.093-3.613-9.501-4.52-9.501-12.426 0-20.942.754-23.207-11.01C3.158 33.778 3 32.157 3 30.5 3 16.417 14.417 5 28.5 5S54 16.417 54 30.5z",
    fill: "#E4A6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.536 26.803l9.004.491s.437-1.92.995-4.734c-2.914.089-5.846.082-8.78-.028-.759 2.555-1.219 4.27-1.219 4.27z",
    fill: "#FF696A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.642.492c-.799-.126-1.749.947-2.749 2.713 1.342.2 2.682.389 4.02.571-.091-1.902-.463-3.155-1.271-3.284z",
    fill: "#D379FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.91 3.779c-1.341-.18-2.68-.368-4.02-.572-.688 1.213-1.398 2.758-2.099 4.472 2 .048 4 .1 6.004.15.122-1.516.169-2.902.115-4.05z",
    fill: "#79D5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.796 7.83c-2-.048-4-.099-6.004-.15a102.448 102.448 0 00-1.728 4.547c2.39.15 4.779.317 7.17.49a81.43 81.43 0 00.562-4.887z",
    fill: "#96FD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.187 17.837a268.688 268.688 0 00-1.438 4.696c2.94.11 5.867.117 8.78.028.3-1.508.633-3.27.956-5.13-2.777.03-5.547.168-8.298.406z",
    fill: "#FF9F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.49 17.43c.268-1.532.523-3.13.744-4.708a640.402 640.402 0 00-7.17-.49 183.022 183.022 0 00-1.876 5.611c2.75-.245 5.52-.382 8.303-.413z",
    fill: "#FFB531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.855 24.696a4.123 4.123 0 100-8.246 4.123 4.123 0 000 8.246z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.303 22.978a2.405 2.405 0 100-4.81 2.405 2.405 0 000 4.81z",
    fill: "#030852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.646 10.005a3.776 3.776 0 00-3.776 3.776v4.571h7.552v-4.571a3.776 3.776 0 00-3.776-3.776z",
    fill: "#69C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.773 10.175a3.78 3.78 0 00-2.65 3.606v4.571H22.87v-4.571a3.776 3.776 0 014.903-3.606z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.648 10.767a5.286 5.286 0 010 10.571V10.767z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.544 23.387H24.46a7.282 7.282 0 01-6.395 7.797 7.285 7.285 0 01-4.873 8.44 8.442 8.442 0 01.957 3.915c0 2.374 1.758 1.818.188 3.356-.861-.76-1.582-.567-2.332-1.437-.511-.593-3.816.482-4.273-.157a25.359 25.359 0 01-4.272-9.953 7.49 7.49 0 01.639-.146 7.282 7.282 0 015.978-9.733 7.282 7.282 0 017.124-8.798h9.171a3.17 3.17 0 013.17 3.17v3.546z",
    fill: "#69C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.986 23.954a7.3 7.3 0 00.16 1.515 7.283 7.283 0 00-5.978 9.733 8.478 8.478 0 00-4.995 2.96 24.955 24.955 0 01-.712-2.814c.21-.058.422-.107.639-.146a7.282 7.282 0 015.978-9.733 7.282 7.282 0 017.124-8.798h5.067a7.283 7.283 0 00-7.283 7.283z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.422 20.3H20.535v10.008a9.237 9.237 0 0016.543 5.65h3.442v1.921c0 1.147.93 2.077 2.076 2.077h5.992c1.147 0 2.077-.93 2.077-2.077V23.544a3.244 3.244 0 00-3.243-3.243z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.186 35.284V55.86c-.882.092-1.779.14-2.686.14-7.72 0-14.64-3.431-19.315-8.852L20.536 20.3l10.65 14.983z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.69 34.372l-8.451 17.27a25.673 25.673 0 01-6.506-6.341l12.803-25 1.84 2.59.314 11.48z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.422 20.3a6.076 6.076 0 0012.151 0H9.422z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.89 25.249a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2zM49.071 25.249a1.1 1.1 0 110-2.2 1.1 1.1 0 010 2.2z",
    fill: "#DC66C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.078 39.453a9.237 9.237 0 01-10.543-9.145V20.3h2.606v10.006c0 4.66 3.452 8.514 7.937 9.146z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.938 25.425a4.487 4.487 0 100-8.975 4.487 4.487 0 000 8.975z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.054 23.555a2.617 2.617 0 100-5.235 2.617 2.617 0 000 5.235z",
    fill: "#030852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.673 31.221v6.082a.66.66 0 01-.66.66h-3.686l-.525-.55a.66.66 0 01-.662-.66l-.628-2.716V32.27l.628-.773c0-1.7.993-2.164 2.694-2.164.707 0 1.116-.955 1.635-.555a3.076 3.076 0 011.204 2.443z",
    fill: "#453D81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.469 28.778v2.927a.565.565 0 01-.565.565h-4.392v-1.049a3.082 3.082 0 014.957-2.443z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.256 36.234v.8a.93.93 0 01-.93.93h-1.153a.66.66 0 01-.661-.66v-3.267h.547c1.214 0 2.197.983 2.197 2.197z",
    fill: "#DA387D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.468 28.778v.975h-4.585a3.082 3.082 0 014.585-.975z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.327 37.964h-1.154a.66.66 0 01-.661-.66v-3.267h.441c-.05 1.046-.018 3.524 1.374 3.927z",
    fill: "#C3247D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shocked_svg__clip0_2637_47653"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/shocked.a6b1b69ca86164c315597e541bcc8eb7.svg";
export { SvgShocked as ReactComponent };